import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'sc-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
})
export class AvatarComponent implements OnInit {
  @Input() photoURL: string;
  @Input() name: string;

  constructor() {}

  ngOnInit() {}
}
